import {Badge, Flex, Heading, Image, Text, useTheme} from "@aws-amplify/ui-react";
import React from "react";
import welcomeImage from '../resources/welcomeImage.jpg'
import EiaCard from "../components/cards/EiaCard";
import Utils from "../commons/Utils/Utils";
import {BestPrices, D4_Boss_Summonings, D4_Calendar, Search, Sell, Tools} from "../components/EiaNavigationLink";
import {Helmet} from "react-helmet-async";
import {BEST_PRICES, SEARCH} from "../commons/enums/Navigation";
import EiaLink from "../components/tables/EiaLink";

const isSmallScreen = Utils.isSmallScreen();
const direction = isSmallScreen ? "column" : "row";

const baseUrl = window.location.origin;

const bestPricesRunesLink = <EiaLink key={"bestPricesRunesLink"} name={"Runes"} link={baseUrl + "/" + BEST_PRICES + "?item_type=Misc&item_sub_type=Rune"} />
const bestPricesGemsLink = <EiaLink key={"bestPricesGemsLink"} name={"Gems"} link={baseUrl + "/" + BEST_PRICES + "?item_type=Misc&item_sub_type=Gem"} />
const bestPricesLairBossKeysLink = <EiaLink key={"bestPricesLairBossKeysLink"} name={"Lair Boss Keys"} link={baseUrl + "/" + BEST_PRICES + "?item_type=Misc&item_sub_type=Lair+Boss+Key"} />

const searchUniquesLink = <EiaLink key={"searchUniquesLink"} name={"Uniques"} link={baseUrl + "/" + SEARCH + "?item_rarity=Unique"} />


const WelcomePage = function(props) {
    const {tokens} = useTheme();

    const eitBadges =         <Flex gap="0.5rem" wrap={"wrap"}>
        <Badge>Diablo 4</Badge><Badge>Market</Badge><Badge>Easy</Badge><Badge>Free</Badge><Badge>Only game items</Badge><Badge>Only game currencies</Badge><Badge>No real money</Badge>
    </Flex>;


    const featureBadges =         <Flex gap="0.5rem" wrap={"wrap"}>
        <Badge>Easy</Badge><Badge>Item Screenshot Detection</Badge><Badge>Price Check</Badge><Badge>Search & Filter</Badge><Badge>Search & Sort</Badge><Badge>Best Prices</Badge><Badge>Tools</Badge>
    </Flex>;

    return (
        <>
            <Helmet>
                <title>Easy Item Trading | Diablo 4</title>
                <link rel="canonical" href={"https://www.easyitemtrading.com/"}/>
                <meta
                    name="description"
                    content="Easy trade Diablo 4 items, runes, lair boss keys, gems and elixirs. Features like item price check, item screenshot detection and multiple currencies."
                />
            </Helmet>
            {
                <Flex direction={direction}>
                    <Flex
                        direction="column"
                        columnGap="1rem"
                    >
                    <EiaCard>
                            <Flex direction="column" columnGap="2rem">
                                <Heading level={3}>Get Started</Heading>
                                <Text fontWeight={tokens.fontWeights.bold} fontSize={tokens.fontSizes.large} textAlign="left">
                                    {[Search, " to browse the market with filters like e.g. ", searchUniquesLink]}
                                </Text>
                                <Text fontWeight={tokens.fontWeights.bold} fontSize={tokens.fontSizes.large} textAlign="left">
                                    {[BestPrices, " to check the best prices for e.g. ", bestPricesRunesLink, ", ", bestPricesGemsLink," or ", bestPricesLairBossKeysLink]}
                                    {/*{[BestPrices, " to check the best prices for e.g. ", stygianStone(), " or ", exquisiteBlood(), " or ", mucusSlickEgg(), " etc."]}*/}
                                </Text>
                                <Text fontWeight={tokens.fontWeights.bold} fontSize={tokens.fontSizes.large} textAlign="left">
                                    {[Sell, " to detect / price check / sell your items via screenshot"]}
                                </Text>
                            </Flex>
                        </EiaCard>
                        <EiaCard>
                            <Flex direction="column" columnGap="2rem">
                                <Heading level={3}>What is Easy Item Trading?</Heading>
                                {eitBadges}
                                <Text fontWeight={tokens.fontWeights.bold} fontSize={tokens.fontSizes.large} textAlign="left">
                                    The goal is to trade easy and fast ingame items against ingame items or ingame currencies (no real money!). Currently we only support the game Diablo 4.
                                    You can register now for free only with e-mail / nickname and start trading!
                                </Text>
                            </Flex>
                        </EiaCard>
                        <EiaCard>
                            <Flex direction="column" columnGap="2rem">
                                <Heading level={3} >What are the features?</Heading>
                                {featureBadges}
                                <Text fontWeight={tokens.fontWeights.bold} fontSize={tokens.fontSizes.large} textAlign="left">
                                    {
                                        [
                                            "You can easy screenshot your item and upload the screenshot on the ", Sell,
                                            " page to create your listing. EasyItemTrading has a text detection feature to find the correct stats."
                                        ]
                                    }
                                </Text>
                                <Text fontWeight={tokens.fontWeights.bold} fontSize={tokens.fontSizes.large} textAlign="left">
                                    {["You can do an automated price check before you ", Sell, " your item to get an idea of the real price."
                                    ]}
                                </Text>
                                <Text fontWeight={tokens.fontWeights.bold} fontSize={tokens.fontSizes.large} textAlign="left">
                                    {
                                        [
                                            "You can filter the ", Search,
                                            " for any implicit stat, affix, greater affix, aspect or unique affix."
                                        ]
                                    }

                                </Text>
                                <Text fontWeight={tokens.fontWeights.bold} fontSize={tokens.fontSizes.large} textAlign="left">
                                    {[
                                        "Easy Item Trading supports multiple currencies like e.g. Gold or Lair Boss Keys what makes the offers sortable. It is easy to find the cheapest offer - checkout ",
                                        Search, " and use table view to sort)."
                                    ]}
                                </Text>
                                <Text fontWeight={tokens.fontWeights.bold} fontSize={tokens.fontSizes.large} textAlign="left">
                                    {[
                                        "A page to show the ", BestPrices,
                                        " for each item type. This is the best way to get a quick overview of e.g. the current prices for diablo 4 lair boss keys."
                                    ]}
                                </Text>
                                <Text fontWeight={tokens.fontWeights.bold} fontSize={tokens.fontSizes.large} textAlign="left">
                                    {[
                                        "Useful ", Tools, " like e.g. ", D4_Calendar,
                                        " or ", D4_Boss_Summonings
                                    ]}
                                </Text>
                            </Flex>
                        </EiaCard>
                    </Flex>
                    {
                        isSmallScreen ? <Flex direction={"row"} justifyContent={"center"}><Image src={welcomeImage} alt={"Easy Item Trading Welcome Image"} width={"70%"}/></Flex>
                            : <Image objectFit={"scale-down"} src={welcomeImage} alt={"Easy Item Trading Welcome Image"} width={"50%"}/>
                    }
                </Flex>
            }
        </>
    );
}
export default WelcomePage;